import { render, staticRenderFns } from "./SmsMailingForm.vue?vue&type=template&id=6d08935b"
import script from "./SmsMailingForm.vue?vue&type=script&lang=js"
export * from "./SmsMailingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports